import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { Logo } from '../components/Logo';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const SetPasswordPage = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [info, setInfo] = useState(null);
  const [invalid, setInvalid] = useState(false);
  const [password, setPassword] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setInvalid(true); return; }
    axios.get(`${API_URL}/api/auth/invite/${encodeURIComponent(token)}`)
      .then((r) => setInfo(r.data))
      .catch(() => setInvalid(true));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== repeat) { setError('Hasła nie są takie same'); return; }
    setBusy(true);
    try {
      const r = await axios.post(`${API_URL}/api/auth/set-password`, { token, password }, { withCredentials: true });
      await checkAuth();
      navigate(r.data.role === 'client' ? '/client-dashboard' : '/dashboard');
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'Nie udało się ustawić hasła');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col" data-testid="set-password-page">
      <div className="p-8"><Logo size="md" /></div>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md card-surface rounded-3xl p-8 md:p-12">
          {invalid ? (
            <>
              <h1 className="display-text text-3xl text-white mb-2">Link nieaktywny</h1>
              <p className="body-text text-[#A1A1A1]">Ten link wygasł lub został już użyty. Poproś trenera o nowy.</p>
            </>
          ) : !info ? (
            <p className="text-white">Ładowanie...</p>
          ) : (
            <>
              <h1 className="display-text text-4xl text-white mb-2">Witaj{info.name ? `, ${info.name.split(' ')[0]}` : ''}</h1>
              <p className="body-text text-[#A1A1A1] mb-8">Ustaw własne hasło do aplikacji. Konto: {info.email}</p>
              {error && <p className="text-red-400 text-sm mb-4" data-testid="set-password-error">{error}</p>}
              <form onSubmit={submit} className="space-y-6">
                <div>
                  <Label className="label-text text-[#A1A1A1] mb-2 block">HASŁO (min. 10 znaków, litery i cyfry)</Label>
                  <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={10} autoComplete="new-password" className="bg-[#0A0A0A] border-[#2A2A2A] rounded-2xl h-12 text-white" />
                </div>
                <div>
                  <Label className="label-text text-[#A1A1A1] mb-2 block">POWTÓRZ HASŁO</Label>
                  <Input type="password" value={repeat} onChange={(e) => setRepeat(e.target.value)} required autoComplete="new-password" className="bg-[#0A0A0A] border-[#2A2A2A] rounded-2xl h-12 text-white" />
                </div>
                <Button type="submit" disabled={busy} className="w-full bg-[#1E1E1E] hover:bg-[#2A2A2A] text-white border border-[#2A2A2A] rounded-full h-12">
                  {busy ? 'Zapisuję...' : 'USTAW HASŁO I WEJDŹ'}
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
